import React from "react";
import "./personlizeloan.scss";
import { getOfferPreFilledData } from "../../selectors";
import { connect } from "react-redux";
import { redirectToAnotherApplication } from "../../actions/crossSellApplicationActions";
import { isMobileNativeApp } from '../../utils/mobileAppCheck';
import { getHeaderStatus } from "../../utils/is.after";
import { updateStandardDataLayerAttributes, setSuccessDataLayer } from "../../analytics/adobe/index";
import { successDataLayer, acceptedDataLayer } from "../../analytics/adobe/dataLayerValues";

export class Congrat extends React.Component {

  constructor ( props ) {
    super( props );

    this.state = {
      url: props.offerPreFilled.ssoReferrer
    };
  }

  redirect=()=>{
    this.props.redirectURL(this.state.url);
  }

  render () {
    let accFirstName=this.props.offerPreFilled.personalInformation.contactInformation.applicantName.firstName;
    let offerAcceptDetails=this.props.offerPreFilled.offerAcceptDetails.isOfferAccepted;
    const isDefaultTemplate =(offerAcceptDetails === "" || offerAcceptDetails.trim().length === 0);
    offerAcceptDetails = (typeof offerAcceptDetails === "string"?offerAcceptDetails.toLowerCase():offerAcceptDetails);
    const isManulTemplate =(offerAcceptDetails === "success" || offerAcceptDetails === "SUCCESS");
    const isHeaderShow=isMobileNativeApp()||getHeaderStatus(this.props.offerPreFilled.channelSource);
    let successFdrText = isHeaderShow?"View all accounts":"View your loan";
    let failedFdrText = isHeaderShow?"Back to all accounts":"Back to accounts";
    let successFDRHeading = isHeaderShow?"Welcome to your Barclays Personal Loan account.":"Your Barclays Personal Loan account is ready.";

    let accDetails ={ ...this.props.offerPreFilled.loanBankInfo };
    let result= accDetails.isAutoPayEnrollEnabled?"Turned On":"Turned Off";
    let dataLayer = !isDefaultTemplate? isManulTemplate ? successDataLayer : acceptedDataLayer : '';
    const { pageName, siteSection }= dataLayer ;
    updateStandardDataLayerAttributes(setSuccessDataLayer(pageName, siteSection, result), true);

    return(
      <div className="row">
        <div className="col col-sm-9 col-md-9 col-lg-9 mx-auto">
          <div className="cl-perl">
            <div className="cl-card cl-congrat">
              <div className="cl-cardbody text-center bor-0">
                <div className="cl-success-con">
                  <div className="congrats-completed-img"></div>
                </div>
                <h4 className="cl-conheadtext head-cap">Congratulations, {accFirstName}!</h4>
                {
                  !isDefaultTemplate?
                    isManulTemplate ?
                      <div>
                        <h4 className="cl-conheadtext">{successFDRHeading}</h4>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                            <p className="cong-p">1. Your loan has been created and you can start to manage your account.</p>
                            <p className="cong-p">2. Your funds will be distributed as you requested in a few business days.</p>
                            <p className="cong-p">3. Please continue to check your email for updates and important information about your loan.</p>
                          </div>
                        </div>
                      </div>
                      :
                      <div>
                        <h4 className="cl-conheadtext">We're finishing up your account.</h4>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-2">
                            <p className="pt-30 con-21 f400">It should take about one business day to set up your account.
                          When it is complete, we'll send you an email notification.</p>
                          </div>
                        </div>
                      </div>
                    :null
                }
              </div>

              <div className="col-12 text-center">
                {
                  !isDefaultTemplate?
                    isManulTemplate ?
                      <button type="submit" data-track="custom-links" className="btn-per" onClick={this.redirect} aria-label="Click to view your loan">
                        {successFdrText}
                      </button>
                      :
                      <div className="mt-100">
                        <button type="submit" data-track="custom-links" className="btn-per" onClick={this.redirect} aria-label="Click to go back to accounts">
                          {failedFdrText}
                        </button>
                      </div>
                    :null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
const mapStateToProps = (state) => ({
  offerPreFilled: getOfferPreFilledData(state)
});
const mapDispatchToProps={ redirectURL: redirectToAnotherApplication };
export default connect(mapStateToProps, mapDispatchToProps)(Congrat);
